module.exports = __webpack_public_path__ + "img/telegram_a.5b06a737.svg";